/* eslint-disable */
import AppNavigation from '../Navigation/AppNavigation'
import LoginNavigation from '../Navigation/LoginNavigation'

const initialState = AppNavigation.router.getStateForAction(AppNavigation.router.getActionForPathAndParams());
export const reducer = (state = initialState, action) => {

  if (action.type.startsWith('Navigation/')) {
    const { routeName } = action;
    const lastRoute = state.routes[state.routes.length - 1];


    if (routeName == lastRoute.routeName) return state
    if (routeName == "home") {
      var modifyState = Object.assign({}, AppNavigation.router.getStateForAction(action, state))
      if( typeof modifyState.routes[modifyState.routes.length -1].params !== 'undefined' )
        modifyState.routes[modifyState.routes.length - 1].params.isScroll = true
      return modifyState
    }

  }
  const newState = AppNavigation.router.getStateForAction(action, state)

  return newState || state
}
export const loginReducer = (state, action) => {
  const newState = LoginNavigation.router.getStateForAction(action, state)


  return newState || state
}
